<template>
  <div class="single-cell-project">
    <l-e-project-index ref="wMyTable" :tableColCheck="tableColCheck" :columns="columns" :is-need-b-s-request="true"
                       :operationPermit="operationPermit" plat-name="SINGLE_CELL" :filterDownEnum="filterDownEnum">
      <template slot="projectOrdinal" slot-scope="{text,record}">
        <template v-if="record?.platformAttribute?.status === 'SUCCESS'">
          <span v-if="judgeProjectLock(record)">
            <span v-if="judgeProjectLockIcon(record)" class="projectLockIcon">
              <el-tooltip content="结果未释放"><a-icon type="lock"/></el-tooltip>
            </span>
            <a @click="getProjectInfo(text,record)">{{ text }}</a></span>
          <el-tooltip v-else content="结果未释放，项目不可查看">
            <span style="cursor:pointer;color: rgba(143,146,153,0.8)">
              <a-icon class="projectLockIcon"
                      type="lock"/>{{ text }}</span>
          </el-tooltip>
        </template>
        <template v-else>
          <span style="color: #939393"> <el-tooltip content="结果未释放，项目不可查看"><a-icon class="projectLockIcon"
                                                                                              type="lock"/></el-tooltip>{{
              text
            }}</span>
        </template>


      </template>
      <template slot="projectOrdinalInfo" slot-scope="{text,record}">
        <span  style="cursor: pointer;color: #2979cb" @click="handleProjectDetail(record)">
          查看<i  class="viewIcon el-icon-view"   style="margin-left:3px;font-size: 15px"
             ></i>
        </span>


      </template>
      <!-- 样本信息 -->
      <span slot="sampleInfo" slot-scope="{text,record}">
          <span style="cursor: pointer;color: #2979cb" @click="lookSampleInfo(record)">查看样本
            <i class="viewIcon" v-html="viewDetailIcon"></i></span>
        </span>

      <!-- 项目状态 -->
      <template slot="projectStatus" slot-scope="scope">
        <div class="flex-inline flex-gap">
          <el-tag style="width: 70px;text-align: center" :type="projectStatusColor[scope.text]">
            {{ projectStatus[scope.text] }}<img v-if="['RUNNING','WAITING'].includes(scope.text)" style="margin-left: 2px" src="images/running2.gif" alt="" />
          </el-tag>
          <w-ellipsis-and-look v-if="scope.text==='FAILED'&&isAdminOrAnalyst" class="w-ellipsis-and-look"
                               :text="scope.record?.platformAttribute?.errorMessage||''"
                               :column="{title:'失败原因'}" :onlyDetail="true">
          </w-ellipsis-and-look>
        </div>

      </template>
      <template slot="extraOperation" slot-scope="{text,record}">
        <el-button
            size="mini"
            type="success"
            @click="handleRawData(record)">原始数据
        </el-button>
        <el-button
            v-if="record.platformAttribute.status !== 'SUCCESS'&&['ADMIN','MANAGER', 'ANALYST'].includes(role)"
            size="mini"
            type="warning"
            @click="handleReSubmit(record)">重新提交
        </el-button>
      </template>

      <!-- 项目状态筛选 -->
      <template slot="filterProjectStatus" slot-scope="filterScope">
        <div class="filter-dropdown">
          <div class="filter-content">
            <el-radio-group v-model="filterScope.selectedKeys[0]">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-radio label="运行中">运行中</el-radio>
                </el-col>
                <el-col :span="12">
                  <el-radio label="失败">失败</el-radio>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-radio label="成功">成功</el-radio>
                </el-col>
              </el-row>
            </el-radio-group>
          </div>
          <div class="filter-actions">
            <a-button type="primary" icon="search" size="small"
                      @click="handleSearch(filterScope.setSelectedKeys, filterScope.selectedKeys, filterScope.confirm, filterScope.column, filterScope.clearFilters)">
              搜索
            </a-button>
            <a-button size="small" @click="handleReset(filterScope.column, filterScope.clearFilters)">取消</a-button>
          </div>
        </div>
      </template>
    </l-e-project-index>

    <!-- 下载原始数据弹窗 -->
    <l-e-down-files-dialog v-if="downRawFilesDialog" :show-dialog.sync="downRawFilesDialog"
                           :downLoadUrl="downLoadRawUrl"/>
    <l-e-down-files-volcano-dialog v-if="downRawFilesVolcanoDialog" :show-dialog.sync="downRawFilesVolcanoDialog"
                                   :downLoadUrl="downLoadRawUrl"/>

    <!-- 快递单号弹窗 -->
    <w-look-detail v-if="infoDialog" :show-dialog.sync="infoDialog" :select-detail="selectDetail"/>

    <!-- 样本信息弹窗 -->
    <sample-info-dialog v-if="sampleInfoDialog" :show-dialog.sync="sampleInfoDialog" :select-detail="selectDetail"/>

  </div>
</template>
<script>
import {permit} from "@/directive/permission/hasPermission"
import {getProjectDetail, projectDetailsUrl, projectRawDataInfo, reSubmitProject} from "@/api/singleCell"
import {tableOperationMixin} from "@/mixins/tableOperation"
import SampleInfoDialog from "@/components/SampleInfoDialog.vue"
import {viewDetailIcon} from "@/utils/iconUtils";
const columns = [
  {
    title: '项目信息',
    dataIndex: 'projectOrdinal',
    key: 'projectOrdinal',
    children: [
      {
        title: '项目号',
        dataIndex: 'projectOrdinal',
        key: 'projectOrdinal',
        className: 'tdProjectNote',
        sorter: true,
        sortDirections: ["descend", "ascend", "descend"],
        searchMethod: 'CASE_LIKE',
        scopedSlots: {filterDropdown: 'filterDropdown', filterIcon: 'filterIcon', customRender: 'projectOrdinal'}
      }, {
        title: '文件信息',
        dataIndex: 'projectOrdinal',
        key: 'projectOrdinalInfo',
        scopedSlots: { customRender: 'projectOrdinalInfo'}
      },
    ],
    permit: `['ADMIN','MANAGER', 'ANALYST'].includes(this.role)`
  },
  {
    title: '项目号',
    dataIndex: 'projectOrdinal',
    key: 'projectOrdinal',
    className: 'tdProjectNote',
    sorter: true,
    sortDirections: ["descend", "ascend", "descend"],
    searchMethod: 'CASE_LIKE',
    scopedSlots: {filterDropdown: 'filterDropdown', filterIcon: 'filterIcon', customRender: 'projectOrdinal'},
    permit: `!['ADMIN','MANAGER', 'ANALYST'].includes(this.role)`
  },
  {
    title: '合同号',
    dataIndex: 'contractNo',
    key: 'contractNo',
    width: 200,
    sorter: true,
    searchMethod: 'CASE_LIKE',
    sortDirections: ["descend", "ascend", "descend"],
    scopedSlots: {filterDropdown: 'filterDropdown', filterIcon: 'filterIcon'}
  },
  {
    title: '类型',
    dataIndex: 'projectType',
    key: 'projectType',
    sorter: true,
    searchMethod: 'CASE_LIKE',
    sortDirections: ["descend", "ascend", "descend"],
    scopedSlots: {filterDropdown: 'filterDropdown', filterIcon: 'filterIcon'}
  },
  {
    title: '物种',
    dataIndex: 'platformAttribute.species',
    key: 'platformAttribute.species',
    searchMethod: 'CASE_LIKE',
    sorter: true,
    sortDirections: ["descend", "ascend", "descend"],
    scopedSlots: {filterDropdown: 'filterDropdown', filterIcon: 'filterIcon'}
  },
  {
    title: '销售姓名',
    dataIndex: 'sales.name',
    key: 'salesName',
    scopedSlots: {filterDropdown: 'filterDropdown', filterIcon: 'filterIcon'}
  },
  {
    title: '客户姓名',
    dataIndex: 'customerInfos',
    key: 'customerName',
    scopedSlots: {filterDropdown: 'filterDropdown', filterIcon: 'filterIcon', customRender: 'customerName'}
  },
  {
    title: '分析员姓名',
    dataIndex: 'analyst.name',
    key: 'analystName',
    scopedSlots: {filterDropdown: 'filterDropdown', filterIcon: 'filterIcon'}
  },
  {title: '样本数量', dataIndex: 'sampleNum', key: 'sampleNum'},
  {title: '样本信息', dataIndex: 'sampleNum', key: 'sampleInfo', scopedSlots: {customRender: 'sampleInfo'}},
  {
    title: '创建时间',
    dataIndex: 'createTime',
    key: 'createTime',
    sorter: true,
    sortDirections: ["descend", "ascend", "descend"]
  },
  {
    title: '合同签署状态',
    dataIndex: 'bsSignStatus',
    key: 'bsSignStatus',
    scopedSlots: {customRender: 'bsSignStatus'}
  },
  {
    title: '原始数据状态',
    dataIndex: 'rawDataInfo',
    key: 'rawDataStatus',
    scopedSlots: {filterDropdown: 'filterRawDataStatus', filterIcon: 'filterIcon', customRender: 'rawDataStatus'}
  },
  {title: '项目备注', dataIndex: 'remark', key: 'remark', width: 200, scopedSlots: {customRender: 'remark'}},
  {
    title: '备注（客户自填）',
    dataIndex: 'customerRemark',
    key: 'customerRemark',
    width: 200,
    scopedSlots: {customRender: 'customerRemark'}
  },
  {
    title: '项目状态',
    dataIndex: 'platformAttribute.status',
    key: 'platformAttribute.status',
    width: 120,
    searchMethod: 'IN',
    scopedSlots: {customRender: 'projectStatus', filterDropdown: 'filterProjectStatus', filterIcon: 'filterIcon'}
  },
  {title: '操作', key: 'operation', scopedSlots: {customRender: 'operation'}, width: 200}
]
export default {
  name: 'SingleCellProject',
  components: {SampleInfoDialog},
  mixins: [tableOperationMixin],
  data() {
    return {
      searchRef: '$refs.wMyTable.$refs.wMyTable',
      tableColCheck: {isShow: true, name: 'singleCell_col4'},
      isOpenNewSearch: true,
      isExcJoinNewSearchKey: true,
      // 弹窗状态
      downRawFilesDialog: false,
      downRawFilesVolcanoDialog: false,
      infoDialog: false,
      sampleInfoDialog: false,
      showDetailDrawer: false,
      // 数据
      downLoadRawUrl: '',
      selectDetail: null,
      currentDetailProject: {},
      role: this.$store.getters["right/getRole"],
      // 状态映射
      projectStatus: {'WAITING': '运行中', 'RUNNING': '运行中', 'SUCCESS': '成功', 'FAILED': '失败'},
      projectStatusColor: {'WAITING': 'warning', 'RUNNING': 'warning', 'SUCCESS': 'success', 'FAILED': 'danger'},
      // 筛选映射
      filterDownEnum: {
        'rawDataStatus': {
          '无': 'NO_DATA',
          '未释放': 'NOT_RELEASED',
          '链接释放': 'LINK_RELEASED',
          '硬盘释放': 'HDD_RELEASED'
        },
        'platformAttribute.status': {'运行中': 'RUNNING,WAITING', '成功': 'SUCCESS', '失败': 'FAILED'}
      },
      // 表格列配置
      //   columns:[],
      viewDetailIcon
    }
  },
  computed: {
    isAdminOrAnalyst() {
      return ['ADMIN', 'MANAGER', 'ANALYST'].includes(this.role)
    },
    columns() {
      return columns.filter(item => (!item.role || item.role.includes(this.role))&&(!item.permit || eval(item.permit)))
    },
  },
  // mounted() {
  //   this.role =
  //   this.columns = columns.filter(item => (!item.role || item.role.includes(this.role))&&(!item.permit || eval(item.permit)))
  // },
  methods: {
    getData() {
      this.$refs.wMyTable.getData()
    },
    // 判断项目是否成功
    isProjectSuccess(record) {
      return record?.platformAttribute?.status === 'SUCCESS'
    },
    // 判断项目是否可查看
    judgeProjectLock(row) {
      return ['USER', 'SALES'].includes(this.role) ? (row?.bsReleased && row?.resReleased) : true
    },
    // 判断是否显示锁定图标
    judgeProjectLockIcon(row) {
      return !(row?.bsReleased && row?.resReleased)
    },
    // 操作权限
    operationPermit(record) {
      const role = localStorage.getItem('delivery_role')
      const user = localStorage.getItem('delivery_user') ? JSON.parse(localStorage.getItem('delivery_user')) : null
      let operationPermit = permit[role]
      if (user === 'USER' && !record.customerIds?.includes(Number(user?.customers?.id))) {
        operationPermit = operationPermit.filter(item => item !== 'project_customer_edit')
      }
      return operationPermit
    },
    // 查看项目详情页面
    async getProjectInfo(text, record) {
      const res = await projectDetailsUrl(record.id)
      if (res?.code === 200) window.open(res.data)
    },

    // 处理原始数据
    handleRawData(record) {
      const status = record?.rawDataInfo?.[0]?.rawDataStatus || ''
      if (status === 'LINK_RELEASED' || status === 'HDD_RELEASED') {
        projectRawDataInfo(record.id).then(res => {
          if (res?.code === 200 && res?.data) {
            if (status === 'LINK_RELEASED') {
              let rawSys = res.data[0]?.rawSys
              if(rawSys==='NA'){
                this.$messageUi.error('原始数据未上传')
              }else {
                this.downLoadRawUrl = res.data[0]?.rawLink
                this[rawSys === 'LINGEN_NETWORK' ? 'downRawFilesDialog' : 'downRawFilesVolcanoDialog'] = true
              }

            }else {
              this.selectDetail = {
                title: '查看硬盘信息',
                data: [
                  {label: '收件人', value: res.data[0]?.rawInfo?.receiverName},
                  {label: '收件人电话', value: res.data[0]?.rawInfo?.receiverPhone},
                  {label: '收件人地址', value: res.data[0]?.rawInfo?.address, inputType: 'textarea'},
                  {label: '快递单号', value: res.data[0]?.rawInfo?.hddInfo?.courierNo, inputType: 'textarea'}
                ]
              }
              this.infoDialog = true
            }
          }
        })
      } else {
        this.$messageUi.error(status === 'NOT_RELEASED' ? '未释放，暂不支持下载' : '无原始数据')
      }
    },
    handleReSubmit(record) {
      this.$confirmUi('您确定要重新提交该项目吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        reSubmitProject(record.id).then(res => {
          if (res?.code === 200) {
            this.$messageUi.success('重试成功')
            this.getData()
          }
        })
    }).catch(() => {})
    },
    // 查看样本信息
    lookSampleInfo(row) {
      this.selectDetail = {title: '查看样本信息', projectId: row.id, platform: 'platform'}
      this.sampleInfoDialog = true
    },
    handleProjectDetail(row) {
      getProjectDetail(row.id).then(res => {
        if (res?.code === 200 && res.data) {
          let projectInfo = res.data?.projectInfo
          let path = projectInfo?.dataZipPath || ''
          let lastIndex = path.lastIndexOf('.')
          this.selectDetail = {
            title: '查看项目信息',
            data: [
              {label: '子项目编号', value: projectInfo?.taskId || ''},
              {label: '原始文件路径', value: path, inputType: 'textarea'},
              {
                label: '最终解析文件路径',
                value: path && path !== 'NA' ? path.substring(0, lastIndex) + '-final' + path.substring(lastIndex) : '',
                inputType: 'textarea'
              },
            ]
          }
          this.infoDialog = true
        }


      })
    },
  }
}
</script>
<style scoped>
.single-cell-project {
  padding: 0;
}

/* 项目号单元格 */
.project-id-cell {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.project-link {
  color: #409eff;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.2s;
}

.project-link:hover {
  color: #66b1ff;
  text-decoration: underline;
}

.project-disabled {
  cursor: not-allowed;
  color: rgba(143, 146, 153, 0.8);
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.lock-icon {
  font-size: 14px;
}

/* 操作链接 */
.action-link {
  cursor: pointer;
  color: #409eff;
  transition: color 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.action-link:hover {
  color: #66b1ff;
}

/* 状态单元格 */
.status-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.status-tag {
  min-width: 56px;
  text-align: center;
}

.error-detail {
  display: flex;
  align-items: center;
}

/* 额外操作按钮 */
.extra-btns {
  display: flex;
  gap: 8px;
  align-items: center;
}

/* 筛选下拉框 */
.filter-dropdown {
  width: 200px;
  padding: 12px;
  position: relative;
  z-index: 9999 !important;
}

.filter-content {
  padding: 4px 8px 12px;
}

.filter-content ::v-deep .el-row {
  margin-bottom: 8px !important;
}

.filter-actions {
  display: flex;
  justify-content: center;
  gap: 8px;
  padding-top: 8px;
  border-top: 1px solid #ebeef5;
}

.filter-actions .ant-btn {
  min-width: 70px;
}

.flex-gap {
  gap: 5px;
}

/deep/ .operation-btns{
  width: 280px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
/deep/ .operation-btns button{
  width: 80px;
  margin-left: 0px!important;

}
</style>
